function normalizeAmount(value: unknown) {
  if (typeof value === 'number') return value;
  if (typeof value !== 'string') return Number(value);

  const trimmed = value.trim();
  if (!trimmed) return undefined;

  const mixedParts = trimmed.split(/\s+/);
  if (mixedParts.length === 2 && mixedParts[1].includes('/')) {
    const whole = Number(mixedParts[0]);
    const [numerator, denominator] = mixedParts[1].split('/');
    const numeratorValue = Number(numerator);
    const denominatorValue = Number(denominator);
    if (
      !Number.isNaN(whole) &&
      !Number.isNaN(numeratorValue) &&
      !Number.isNaN(denominatorValue) &&
      denominatorValue !== 0
    ) {
      return whole + numeratorValue / denominatorValue;
    }
  }

  if (trimmed.includes('/')) {
    const [numerator, denominator] = trimmed.split('/');
    const numeratorValue = Number(numerator);
    const denominatorValue = Number(denominator);
    if (!Number.isNaN(numeratorValue) && !Number.isNaN(denominatorValue) && denominatorValue !== 0) {
      return numeratorValue / denominatorValue;
    }
  }

  const parsedValue = Number(trimmed);
  return Number.isNaN(parsedValue) ? undefined : parsedValue;
}

export { normalizeAmount };
